import { TextField, Tooltip } from '@mui/material'
import type { TemplateHint } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  setTemplateHintErrorMessage,
  updateTemplateHint,
} from 'src/state/ducks/templates/templateHints/actions'

const HintName: FC<{
  hint: TemplateHint
}> = ({ hint }) => {
  const dispatch = useDispatch()
  const [focused, setFocused] = useState(false)
  const [value, setValue] = useState(hint.name ?? '')

  const handleBlur = () => {
    setFocused(false)
    dispatch(
      updateTemplateHint(hint.id ?? '', {
        ...hint,
        name: value,
      }),
    )
  }

  return (
    <Tooltip title={!focused ? value : ''} placement="top">
      <TextField
        inputProps={{ 'aria-label': 'ヒント名' }}
        value={value}
        onChange={e => {
          setValue(e.target.value)
          dispatch(setTemplateHintErrorMessage(''))
        }}
        onFocus={() => setFocused(true)}
        onBlur={handleBlur}
        multiline
        {...(!focused && { rows: 1 })}
        fullWidth
        size="small"
      />
    </Tooltip>
  )
}

export default HintName
